<template>
  <article>
    <section>
      <img :src="`${baseURL}/storage/app/img/judge/${data.judge_picture}`">
      <div class="box-content">
        <div class="box"></div>
        <div class="box-text">
          <h2>{{ data.name_judge }}</h2>
          <span v-html="data.content"></span>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import { constantsComputed } from '@/store/helpers'

export default {
  props: {
    data: Object
  },

  computed: {
    ...constantsComputed
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

article {
  section {
    img {
      width: 100%;
      height: auto;
      background-color: $light;
    }

    .box-content {
      .box {
        float: left;
        margin-top: 5px;
        width: 15px;
        height: 15px;
        background-color: $active;
      }

      .box-text {
        margin-left: 22px;
        font-size: 1rem;
        margin-bottom: 16px;

        h2 {
          margin-top: 8px;
          margin-bottom: 12px;
          font-size: 1.4rem;
        }

        span {
          opacity: 0.6;
          font-size: 0.8125rem;
          line-height: 1;
          font-family: var(--body-upscale-font-family, Sarabun);
        }
      }
    }
  }
}
</style>
